import { render, staticRenderFns } from "./FooterLinksAbout.vue?vue&type=template&id=493c568e"
import script from "./FooterLinksAbout.vue?vue&type=script&lang=js"
export * from "./FooterLinksAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports